import React, { useEffect, useState } from "react";
import title from "../../Assets/title.jpg";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import fackbookicon from "../../Assets/fackbookicon.svg";
import googleIcon from "../../Assets/googleIcon.svg";
import appleicon from "../../Assets/appleicon.svg";
import "../../Styles/Auth/Login.css";
import { useNavigate } from "react-router-dom";
import { Imagecontainer } from "./Register";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";

const Login = () => {
  const history = useNavigate();
  const [hover, sethover] = useState(false);
  const [showOtpInput, setOtpInput] = useState(false);

  // Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyCH7bVP673lvYtWbXbQzAP3mv2wep6NdO8",
  authDomain: "edifai-forms.firebaseapp.com",
  projectId: "edifai-forms",
  storageBucket: "edifai-forms.firebasestorage.app",
  messagingSenderId: "1026219247928",
  appId: "1:1026219247928:web:55b6e37cec659eb67cd9cd",
  measurementId: "G-85CFES16LD"
  };
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  // Third-party providers
  const googleProvider = new GoogleAuthProvider();
  const facebookProvider = new FacebookAuthProvider();

  const [errors, setErrors] = useState({
    emailOrNumber: "",
  });

  const [emailOrNumber, setEmailOrNumber] = useState("");
  //social login
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      history("/forms/list");
      console.log("Google User Info:", result.user);
    } catch (error) {
      console.error("Google Login Error:", error.message);
    }
  };

  const handleFacebookLogin = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log("Facebook User Info:", result.user);
    } catch (error) {
      console.error("Facebook Login Error:", error.message);
    }
  };

  const next = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!String(emailOrNumber || "").trim())
      newErrors.emailOrNumber =
        "Please enter your email address or mobile number";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Update errors state
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {
        input: emailOrNumber,
      });
      if (response.status === 200) {
        if (response.message === "User not found") {
          setErrors((pre) => ({ ...pre, emailOrNumber: "user not found" }));
        }
        setOtpInput(true);
      } else {
        console.log("Error in login:", response.data.error);
      }
    } catch (error) {
      console.error("Error navigating:", error);
    }
  };

  const isEmail = (input) => /\S+@\S+\.\S+/.test(input);
  const isPhoneNumber = (input) => /^\d{10}$/.test(input); // Assuming 10-digit phone number

  //find number or email
  const findNumberOrEmail = (input) => {
    // let user;
    if (isEmail(input)) {
      return "Email";
    } else if (isPhoneNumber(input)) {
      return "Phone Number";
    }
  };

  //re send time
  const [otpTimer, setOtpTimer] = useState(10);
  const [otpVerified, setOtpVerified] = useState(false);

  // Countdown timer for OTP validity
  useEffect(() => {
    let timerInterval;

    if (showOtpInput && otpTimer > 0 && !otpVerified) {
      timerInterval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    } else if (otpTimer === 0 || otpVerified) {
      clearInterval(timerInterval);
    }

    return () => clearInterval(timerInterval);
  }, [showOtpInput, otpTimer, otpVerified]);


  return (
    <div className="registerpage-container">
      <div className="" style={{ flex: 1, }}>
        <Imagecontainer />
      </div>
      {/* <div className="register-form-contaienr"> */}
      <div
        style={{
          // width: "45%",
          flex: 1,
          // display: "flex",
          // flexDirection: "column",
          gap: "0.875rem",
          position: "relative",
          // backgroundColor: "green",
        }}
      >
        {/* <div className="register-form-head-container">
          <img
            src={title}
            alt="title"
            style={{ width: "30%", height: "auto" }}
          />
          <h2>Sign in </h2>
          <p>to access Forms</p>
        </div> */}
        {!showOtpInput ? (
          <div className="register-form-container">
            <img
              src={title}
              alt="title"
              style={{ width: "20%", height: "auto" }}
            />
            <h2 style={{ marginTop: '1rem', fontFamily: "EuclidMedium" }}>To access forms sign in</h2>
            <form onSubmit={next}>
              <div className="form-group">
                <label htmlFor="emailOrNumber">
                  Email or mobile number
                  <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="emailOrNumber"
                  placeholder="Enter Email address or mobile number"
                  value={emailOrNumber}
                  onChange={(e) => {
                    setErrors((pre) => ({ ...pre, emailOrNumber: "" }));
                    setEmailOrNumber(e.target.value);
                  }}
                />
                {errors.emailOrNumber && (
                  <span className="register-error-text">
                    {errors.emailOrNumber}
                  </span>
                )}
              </div>
              <button type="submit" className="register-btn">
                Next
              </button>
            </form>
            {/* <div className="contine-line-conponent">
              <hr style={{ width: "30%" }} />
              <span>Or continue with</span> <hr style={{ width: "30%" }} />
            </div>
            <div className="other-platform-container">
              <div
                className="otherway-icon-container container1"
                onMouseEnter={() => sethover(1)}
                onMouseLeave={() => sethover("")}
                style={{
                  boxShadow:
                    hover === 1 && "0px 10px 13px 0px rgba(0, 0, 0, 0.13)",
                  cursor: hover === 1 ? "pointer" : "default",
                  border: hover === 1 ? "0px " : "1px solid #dddfdd",
                }}
                onClick={handleGoogleLogin}
              >
                <img src={googleIcon} alt="googleIcon" />
              </div>
              <div
                className="otherway-icon-container container2"
                onMouseEnter={() => sethover(2)}
                onMouseLeave={() => sethover("")}
                style={{
                  boxShadow:
                    hover === 2 && "0px 10px 13px 0px rgba(0, 0, 0, 0.13)",
                  cursor: hover === 2 ? "pointer" : "default",
                  border: hover === 2 ? "0px " : "1px solid #dddfdd",
                }}
                onClick={handleFacebookLogin}
              >
                <img src={fackbookicon} alt="fackbookicon" />
              </div>
              <div
                className="otherway-icon-container container3"
                onMouseEnter={() => sethover(3)}
                onMouseLeave={() => sethover("")}
                style={{
                  boxShadow:
                    hover === 3 && "0px 10px 13px 0px rgba(0, 0, 0, 0.13)",
                  cursor: hover === 3 ? "pointer" : "default",
                  border: hover === 3 ? "0px " : "1px solid #dddfdd",
                }}
              >
                <img src={appleicon} alt="appleicon" />
              </div>
            </div> */}
            <div className="resign-up-text-container" style={{ marginTop: '16px' }}>
              Don’t have an account?{" "}
              <span onClick={() => history("/sign-up")}>Sign up</span>
            </div>
          </div>
        ) : (
          <LoginOtpComponent
            findNumberOrEmail={findNumberOrEmail}
            emailOrNumber={emailOrNumber}
            setOtpInput={setOtpInput}
          />

        )}
      </div>
      {/* </div> */}
    </div>
  );
};

const LoginOtpComponent = ({
  findNumberOrEmail,
  emailOrNumber,
  setOtpInput,
  setOtpVerified,
}) => {
  const [errors, setErrors] = useState({
    otp: "",
  });
  const [otp, setOtp] = useState("");

  const [otpTimer, setOtpTimer] = useState(10);
  const history = useNavigate();

  const { login } = useAuth();
  //verfiy otp
  const verifyandLogin = async (e) => {
    e.preventDefault();

    const newError = {};
    if (!String(otp || "").trim()) newError.otp = "OTP is required";
    if (String(otp || "").trim().length !== 6) {
      newError.otp = "Invalid OTP";
    }
    if (Object.keys(newError).length > 0) {
      setErrors(newError);
    }
    try {
      console.log(emailOrNumber, otp);
      const response = await axios.post(
        `${process.env.REACT_APP_API}/login-vefiy-otp`,
        {
          input: emailOrNumber,
          otp: parseInt(otp),
        }
      );
      if (response.status === 200) {
        if (
          response.data.message === "OTP not found or expired" ||
          response.data.message === "Invalid OTP"
        ) {
          setErrors((pre) => ({ ...pre, otp: "Enter Correct otp" }));
        } else if (response.data.message === "OTP expired") {
          setErrors((pre) => ({ ...pre, otp: "OTP expired" }));
        }
        const token = response.data.token;
        const userId = response.data.user._id;
        await login(token, userId);
        history("/forms/list");
      }
    } catch (error) {
      console.log(error);
      setErrors((pre) => ({ ...pre, otp: "Failed to verify otp" }));
    }
  };

  // Countdown timer for OTP validity
  useEffect(() => {
    let timerInterval;

    if (otpTimer > 0) {
      timerInterval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    } else if (otpTimer === 0) {
      clearInterval(timerInterval);
    }

    return () => clearInterval(timerInterval); // Clean up interval
  }, [otpTimer]);

  //resend otp
  const resendOtp = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {
        input: emailOrNumber,
      });
      setErrors((pre) => ({ ...pre, otp: "" }));
      if (response.status === 200) {
        setOtpTimer(60);
        console.log("-----------------------", response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="register-form-container">
   <img
              src={title}
              alt="title"
              style={{ width: "20%", height: "auto" }}
            />
            <h2 style={{ marginTop: '1rem', fontFamily: "EuclidMedium" }}>Sign in </h2>
            <p style={{ marginBottom: '1rem', fontFamily: "EuclidMedium" }}>to access Forms</p>
      <form onSubmit={verifyandLogin}>

        <div className="form-group">
          <label htmlFor="emailOrNumber">
            <>{findNumberOrEmail(emailOrNumber)}</>
            <span>*</span>
          </label>
          <div
            className="form-control"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              t
              id="emailOrNumber"
              placeholder="Enter Email address or mobile number"
              value={emailOrNumber}
              readOnly
            />

            <button
              style={{
                marginTop: "0",
                color: "#2D7DF9",
                fontFamily: "EuclidMedium",
              }}
              onClick={() => setOtpInput(false)}
            >
              Change
            </button>
          </div>
          {errors.emailOrNumber && (
            <span className="register-error-text">{errors.emailOrNumber}</span>
          )}
        </div>
        <div className="form-group" style={{ marginTop: "1rem" }}>
          <label htmlFor="emailOrNumber">
            Enter the one-time password send to your email<span>*</span>
          </label>
          <input
            type="number"
            className="form-control"
            id="emailOrNumber"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => {
              setErrors((pre) => ({ ...pre, otp: "" }));
              setOtp(e.target.value);
            }}
          />
          {errors.otp && (
            <span className="register-error-text">{errors.otp}</span>
          )}
          {otpTimer > 0 ? (
            <span className="resend-container">Resend {otpTimer}s</span>
          ) : (
            <span
              onClick={resendOtp}
              style={{ color: "blue", cursor: "pointer" }}
            >
              Resend
            </span>
          )}
        </div>
        <button type="submit" className="register-btn">
          Verify
        </button>
      </form>
    </div>
  );
};

export default Login;
